export const MODULES = {
  INSPECTION_APP: "inspection-app",
  RESORT_BOOKING: "resort-booking",
  E_TICKETING: "e-ticketing",
  MAIN_SITE: 'main-site',
  FLEET_MANAGEMENT: 'fleet-management',
  JEEP_RALLY: "jeep-rally",
  ALL: "*",
};

export const SERVICES = {
  CHAIRLIFT_AND_CABLE_CAR: "chairlift-and-cable-car",
  SIGHTSEEING: "sightseeing",
  BOATING: "boating",
  SOFTWHEEL_TRAIN: "softwheel-train",
  ALL: "*",
}

export const FEATURES = {
  ROUTE: "Route",
  ROUTE_PRICE: "Route Price",
  ROUTE_TIMING: "Route Timing",
  ADD_PEOPLE_COUNT: "Add People Count",
  CMS: "CMS",
}

export const SIDEMENU_ITEMS = {
  DASHBOARD: "DashboardSideMenu",
  USERS: "UsersManagementSideMenu",
  
  INSPECTION: "InspectionSideMenu",
  RESORT: "ResortBookingSideMenu",
  MAINWEBCMS: "MainWebCMSSideMenu",
  E_TICKETING: "EticketingSideMenu",
  
  CHAIRLIFT_AND_CABLE_CAR: "ChairLiftAndCableCarSideMenu",
  SIGHTSEEING: "SightseeingSideMenu",
  BOATING: "BoatingSideMenu",
  SOFTWHEEL_TRAIN: "SoftwheelTrainSideMenu",

  MAIN_SITE: "MainSiteSideMenu",
  FLEET_MANAGEMENT: "FleetManagementSideMenu",

  JEEP_RALLY: "JeepRallySideMenu",
};
